//import React, { Component } from 'react';
import React from 'react';


const Error = (props) => (
    <div {...props} style={{ color: '#A94442' }} />
);


export const requerido = (value) => {
    if(value==null)
        return false;
    value = ('' + value).trim();
    if (!value) {
        return false;
    }
    return true;
};



export const password = (value, props, components) => {
    
    value = ('' + value).trim();
    var decimal=  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/;
    if (!value.match(decimal)) {
        return (
            <Error>{'Políticas de Password: longitud mínima de 8 caracteres, máxima de 15 y contar con letras minúsculas, mayúsculas y caracteres especiales.'}</Error>
        );
    }
};

export const validateEmail=(email)=> {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}